var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ textAlign: _vm.config.text.textAlign })},[_c('span',{staticClass:"text",style:(_vm.getStyle())},[_vm._v(_vm._s(_vm.config.text.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }